import { mergeDeepRight } from 'ramda';

type StylesConfig = {
  checkboxColor?: string;
};

const baseStyles = ({ checkboxColor }: StylesConfig = {}) => ({
  chart: { width: '100%', height: 500 },
  container: {
    margin: '1.875rem 0 0 !important',
    justifyContent: 'center !important',
    boxShadow:
      '0 0.0625em 0 0 rgba(0,0,0,0.03), 0 0.125em 0.375em 0 rgba(0,0,0,0.06)',
  },
  fixMargin: {
    margin: '0 -1em !important',
  },
  chartContent: {
    backgroundColor: '#fff',
    padding: '0 2rem !important',
  },
  header: {
    margin: '0 0 0 3.75rem !important',
    fontSize: '.75rem !important',
    color: '#646464 !important',

    '& i': {
      fontSize: '1.25rem !important',
    },
  },
  headerIcon: {
    fontSize: '1em !important',
    color: '#683caf !important',
    marginRight: '.25em !important',
  },
  headerIcon2: {
    fontSize: '1em !important',
    color: '#150c24 !important',
    marginRight: '.25em !important',
  },
  headerLabel: {
    marginRight: '.625rem !important',
    display: 'inline-block',
  },
  headerCheckBox: {
    marginLeft: '.625rem !important',
    zIndex: 1,

    '& label': {
      fontSize: '.75em !important',
      marginLeft: '.625em !important',
      '&:before': {
        backgroundColor: `${checkboxColor} !important`,
        borderColor: `${checkboxColor} !important`,
        color: `${checkboxColor} !important`,
      },
      '&:after': {
        backgroundColor: `${checkboxColor} !important`,
        borderColor: `${checkboxColor} !important`,
        borderRadius: '.21428571rem !important',
        color: '#fff !important',
      },
    },
  },
  noPadding: {
    padding: '0 !important',
  },
  download: {
    background: 'transparent',
    position: 'absolute',
    bottom: 0,
  },
  legend: {
    marginTop: '2rem',
    paddingBottom: '2rem',
  },
  calendarLegend: {
    margin: '2rem 0 1rem 0',
  },
  ref: {
    width: '100%',
    padding: '0 !important',
    position: 'relative',
    margin: '0 !important',
  },
  headerBlock: {},
  footer: {},
  footerBlock: {},
  formSelect: {},
  headerText: {},
});

const getBaseStyles = (additionalStyles: object, stylesConfig?: StylesConfig) =>
  mergeDeepRight(baseStyles(stylesConfig), additionalStyles);

export { baseStyles, getBaseStyles };
